module.exports = __webpack_public_path__ + "static/media/facebook.30a9d4eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/LayoutFooter/facebook.svg
// module id = 507
// module chunks = 2